<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <form @submit.prevent="applyFilter">
          <h6 class="heading-small text-muted mb-4">Search</h6>
          <div class="row">
            <div class="col">
              <a-input placeholder="Search by" v-model="search">
                <a-select
                  slot="addonAfter"
                  default-value="card_number"
                  style="width: 90px"
                  v-model="searchType"
                  @change="searchTypeOnChange"
                >
                  <a-select-option value="card_number">
                    Card #
                  </a-select-option>
                  <a-select-option value="serial_no">
                    Serial #
                  </a-select-option>
                  <a-select-option
                    v-if="!hasCardAssignmentModule"
                    value="card_order_id"
                  >
                    Batch #
                  </a-select-option>
                </a-select>
              </a-input>

              <!-- <a-input
                placeholder="Card Number"
                v-model="table.filters.card_number"
              >
              </a-input> -->
            </div>
          </div>
        </form>
        <br />
        <form role="form" @submit.prevent>
          <div>
            <div>
              <h6 class="heading-small text-muted mb-4">Filter by Status</h6>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.filters.card_status_id"
                  show-search
                  mode="multiple"
                  optionFilterProp="children"
                >
                  <a-select-option
                    v-for="cardStatus in options.cardStatuses"
                    v-bind:value="cardStatus.id"
                    v-bind:key="cardStatus.id"
                  >
                    {{ cardStatus.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <h6 class="heading-small text-muted mb-4">
                Filter by Membership Program
              </h6>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.filters.membership_program_id"
                  show-search
                  optionFilterProp="children"
                >
                  <a-select-option :value="null">All</a-select-option>
                  <a-select-option
                    v-for="membershipProgram in options.membershipPrograms"
                    v-bind:value="membershipProgram.id"
                    v-bind:key="membershipProgram.id"
                  >
                    {{ membershipProgram.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>

          <div v-if="!hasCardAssignmentModule">
            <div>
              <h6 class="heading-small text-muted mb-4">
                Filter by Card Types
              </h6>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.filters.card_type_id"
                  show-search
                  mode="multiple"
                  optionFilterProp="children"
                >
                  <a-select-option
                    v-for="cardType in options.cardTypes"
                    v-bind:value="cardType.id"
                    v-bind:key="cardType.id"
                  >
                    {{ cardType.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <base-button
                type="primary btn-block"
                class="my-4"
                @click.prevent="applyFilter"
              >
                <div>Apply Filter</div>
              </base-button>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
          @toggleCheckbox="toggleCheckbox"
        >
          <template #headerButtons>
            <!-- <base-button
              id="new"
              class="float-right ml-1"
              type="warning"
              size="sm"
              @click="openDrawer()"
              :disabled="!toTransfer"
              >Transfer</base-button
            > -->

            <base-button
              id="new"
              v-if="
                selectedActions.includes('Activate') &&
                table.filters.card_status_id == 2
              "
              class="float-right ml-1"
              type="primary"
              size="sm"
              @click="activateCards()"
              :disabled="!toActivate"
              >Activate
            </base-button>

            <base-button
              id="new"
              v-if="
                selectedActions.includes('Activate') &&
                table.filters.card_status_id == 3
              "
              class="float-right ml-1 btn-error"
              type="primary"
              size="sm"
              @click="deactivateCards()"
              :disabled="!toDeactivate"
              >Deactivate
            </base-button>
          </template>

          <template #formDrawer>
            <a-drawer
              :width="historyDrawer.width"
              :placement="historyDrawer.placement"
              :visible="historyDrawer.visible"
              @close="closeHistoryDrawer"
            >
              <CardHistory
                :viewMode="viewMode"
                :cardData="cardData"
                @closeDrawer="closeHistoryDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{ tableProps }">
            <button
              id="history"
              class="btn btn-success btn-sm"
              @click.prevent="cardHistory(tableProps.rowData)"
            >
              View
            </button>
            <!-- <base-dropdown class="nav-link pr-0 float-right" position="right">
              <div class="media align-items-center" slot="title">
                <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
              </div>
              <template>
                <div class="dropdown-header noti-title">
                  <h6 class="text-overflow m-0">ACTIONS</h6>
                </div>

                <div./_CardTransferOutForm.vue
                  class="dropdown-item"
                  @click="cardHistory(tableProps.rowData)"
                >
                  <i class="fa fa-list-ul"></i>
                  Card History
                </div>
              </template>
            </base-dropdown> -->
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import CardHistory from './CardHistory.vue';
import HTTPRequest from '../../controllers/httpRequest';
import secureStorage from '../../controllers/secureStorage';
import { mapGetters } from 'vuex';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    CardHistory
  },
  data() {
    return {
      gradientType: 'gradient-teal',
      search: null,
      searchType: 'card_number',
      cardData: null,
      checkedItems: [],
      toTransfer: false,
      hasCardAssignmentModule: false,
      toActivate: false,
      toDeactivate: false,
      activating: false,
      drawer: {
        visible: false,
        width: 480,
        placement: 'right'
      },
      historyDrawerCtr: 0,
      historyDrawer: {
        visible: false,
        width: 700,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Cards',
        apiUrl:
          '/api/v1/cards?origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        fields: [],
        filters: {
          card_number: null,
          membership_program_id: null,
          card_type_id: [],
          card_status_id: [],
          hasFilter: false
        }
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      },

      options: {
        cardStatuses: [],
        membershipPrograms: [],
        cardTypes: []
      }
    };
  },
  computed: {
    tableFields() {
      return [...this.table.fields];
    },
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },
  methods: {
    async setTableFields() {
      let fields = [
        '__checkbox',
        { name: 'actions', title: '' },
        { name: 'card_number', title: 'Card #' },
        { name: 'serial_no', title: 'Serial' },
        { name: 'cardStatus.name', title: 'Status' },
        { name: 'card_order_id', title: 'Batch #' },
        { name: 'membershipProgram.name', title: 'Membership Program' },
        { name: 'cardType.name', title: 'Card Type' },
        { name: 'site.name', title: 'Site', length: '5px' }
      ];
      this.table.fields.length = 0;
      if (this.hasCardAssignmentModule) {
        fields = fields.filter(
          (item) =>
            item.name !== 'cardType.name' &&
            item.name !== 'card_order_id' &&
            item.name !== 'serial_no'
        );
      }

      fields.forEach((column) => {
        this.table.fields.push(column);
      });
    },
    async getCardAssignmentFeature() {
      const response = await HTTPRequest.getRequest(
        `/api/v1/clp_accounts/settings/CARD_ASSIGNMENT_FEATURE`
      );

      if (response.account_id) {
        this.hasCardAssignmentModule = response.value == 'true';
      }
    },
    searchTypeOnChange() {
      this.table.filters.hasFilter = false;

      if (this.search != null && this.search != '') {
        this.table.filters['card_order_id'] = null;
        this.table.filters['card_number'] = null;
        this.table.filters['serial_no'] = null;
        this.table.filters[this.searchType] = this.search;
        // this.table.filters.hasFilter = true;
        // this.setFilter();
      }
    },

    openDrawer() {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.cardData = this.checkedItems;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.cardData = null;
      this.setFilter();
    },

    // ---- START - History Module ---- //
    closeHistoryDrawer() {
      this.historyDrawer.visible = false;
      this.cardData = null;
      this.setFilter();
    },

    cardHistory(rowData) {
      this.historyDrawer.visible = true;
      this.historyDrawerCtr++;
      // console.log(rowData);
      this.cardData = rowData;
      // console.log("Show drawer of card history.")
    },

    // ---- END - History Module ---- //
    applyFilter() {
      if (
        this.table.filters['membership_program_id'] == null &&
        this.table.filters['card_number'] == null &&
        this.table.filters['card_type_id'].length == 0 &&
        this.table.filters['card_status_id'].length == 0 &&
        this.table.filters['card_order_id'] == null &&
        this.table.filters['serial_no'] == null
      ) {
        this.table.filters.hasFilter = false;
      } else {
        this.table.filters.hasFilter = true;
      }
      this.setFilter();
    },
    setFilter() {
      this.$root.$emit('refreshTable');
    },

    toggleCheckbox(items) {
      let _items = [];

      for (const item of items) {
        _items.push({
          id: item.id,
          membership_program_id: item.membership_program_id,
          card_status_id: item.card_status_id,
          card_number: item.card_number,
          cardStatus: {
            status_code: item.cardStatus.status_code
          },
          card_type_id: item.card_type_id
        });
      }

      this.checkedItems = _items;
    },

    async getCardStatuses() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_card_statuses'
      );
      let data = [];
      for (let x in response.data) {
        if (response.data[x].model == 'cards') {
          data.push(response.data[x]);
        }
      }

      this.options.cardStatuses = data;
    },

    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.options.membershipPrograms = response.data;
    },

    async getCardTypes(membershipProgramId) {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${membershipProgramId}/card_types`
      );
      this.options.cardTypes = data;
    },

    async activateCards() {
      this.activating = true;
      const response = await HTTPRequest.putRequest(
        '/api/v1/cards/activate_cards?origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        {
          cards: this.checkedItems
        }
      );

      if (response.message == 'Success') {
        this.$root.$emit('refreshTable');
        this.$notification.success({
          message: 'Success',
          description: 'Card has been activated.'
        });
      } else {
        this.$notification.error({
          message: 'Error',
          description: 'Something went wrong. Please try again.'
        });
      }
      this.activating = false;
    },

    async deactivateCards() {
      this.activating = true;
      const response = await HTTPRequest.putRequest(
        '/api/v1/cards/deactivate_cards?origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        {
          cards: this.checkedItems
        }
      );

      if (response.message == 'Success') {
        this.$root.$emit('refreshTable');
        this.$notification.success({
          message: 'Success',
          description: 'Card has been de-activated.'
        });
      } else {
        this.$notification.error({
          message: 'Error',
          description: 'Something went wrong. Please try again.'
        });
      }
      this.activating = false;
    }
  },

  async created() {
    await this.getCardAssignmentFeature();
    this.$store.dispatch('setCurrentModule', 'CardInventory');
    await this.setTableFields();
    await this.getCardStatuses();
    await this.getMembershipPrograms();
  },
  watch: {
    search(val) {
      if (val == '') {
        this.search = null;
      } else {
        this.table.filters.hasFilter = true;
      }

      this.table.filters[this.searchType] = val;
    },
    'table.filters.membership_program_id': function (val) {
      this.options.cardTypes = [];
      if (val != null && !this.hasCardAssignmentModule) {
        this.getCardTypes(val);
      }
    },

    checkedItems: function (items) {
      let canTransfer = 0,
        canActivate = 0,
        others = 0,
        canDeactivate = 0;

      if (items.length > 0) {
        for (const item of items) {
          switch (item.cardStatus.status_code) {
            case 'CARD_RECEIVE':
              canTransfer++;
              canActivate++;
              break;
            case 'CARD_ACTIVATE':
              canTransfer++;
              canDeactivate++;
              break;
            default:
              others++;
              break;
          }
        }

        if (canDeactivate > 0) {
          this.toDeactivate = true;
        }

        if (canTransfer > canActivate && others == 0) {
          console.log('Can transfer card.');
          this.toTransfer = true;
          this.toActivate = false;
        }

        if (
          canTransfer == canActivate &&
          canTransfer != 0 &&
          canActivate != 0 &&
          others == 0
        ) {
          console.log('Can transfer or activate card.');
          this.toTransfer = true;
          this.toActivate = true;
        }

        if (canTransfer >= 0 && canActivate >= 0 && others != 0) {
          console.log('Cannot activate or transfer card.');
          this.toTransfer = false;
          this.toActivate = false;
        }
      } else {
        this.toTransfer = false;
        this.toActivate = false;
        this.toDeactivate = false;
      }
    }
  }
};
</script>

<style scoped></style>
